import axios from "axios";

const WOO_PRODUCTS_BASEURL = process.env.VUE_APP_WOO_API_BASE_URL + '/wp-json/wc/v3/products';

export default class ProductClient {
    constructor() {
        this.$http = axios.create({
            baseURL: WOO_PRODUCTS_BASEURL,
            params:  {
                consumer_key:    process.env.VUE_APP_WOO_KEY,
                consumer_secret: process.env.VUE_APP_WOO_SECRET
            },
            headers: {
                'Accept': 'application/json'
            }
        })
    }

    getProduct(productId) {
        return this.$http.get('/' + productId)
            .then(response => response.data);
    }
}
